import type { Role } from '../../utils/roles';
import type { RolesDictionary } from './types';

export function rolesArrayToDictionary(roles: Role[]): RolesDictionary {
  const userRoles: RolesDictionary = {};
  for (const role of roles) {
    userRoles[role] = true;
  }
  return userRoles;
}
